export default __webpack_public_path__ + "static/media/mental_health_trend_header.3a14e3a3.png";